// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconSyrupusdt } from "../../../icons/mono/build/icon-syrupusdt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SyrupusdtIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconSyrupusdt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SyrupusdtIcon.displayName = 'SyrupusdtIcon';
}

export default SyrupusdtIcon;